import React from "react";

export const createFormatedData = (
  dateString: string,
  dateMMDDYYYY: boolean
) => {
  if (dateMMDDYYYY) {
    // Return in MM/DD/YYYY format (US format)
    return `${dateString.slice(3, 5)}/${dateString.slice(
      0,
      2
    )}${dateString.slice(5)}`;
  } else {
    // Return in DD/MM/YYYY format (European format)
    return dateString;
  }
};
